import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

// PrimeNG Imports
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { CarouselModule } from 'primeng/carousel';
import { ImageModule } from 'primeng/image';
import { PasswordModule } from 'primeng/password';
import { DialogModule } from 'primeng/dialog'; // <--- IMPORTANT

// Services
import { AuthService } from '../../core/services/infrastructure/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule, // Required for Modal ngModel
    InputTextModule,
    ButtonModule,
    CheckboxModule,
    CarouselModule,
    ImageModule,
    PasswordModule,
    DialogModule // Required for Modal
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements OnInit {
  /** Services */
  private router = inject(Router);
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);

  /** Form Variables */
  public form!: FormGroup;
  protected loading: boolean = false;

  /** Forgot Password Variables */
  public forgotPasswordVisible = false;
  public recoveryEmail = '';
  public loadingRecovery = false;

  public carouselItems = [
    {
      icon: 'pi pi-chart-line',
      title: 'Gestão Financeira',
      text: 'Controle fluxo de caixa, inadimplência e projeções em tempo real.'
    },
    {
      icon: 'pi pi-file-edit',
      title: 'Contratos Inteligentes',
      text: 'Gerencie vigências, renovações e documentos em um só lugar.'
    },
    {
      icon: 'pi pi-users',
      title: 'Relacionamento CRM',
      text: 'Centralize o histórico de clientes e potencialize suas vendas.'
    }
  ];

  constructor() {
    // Initializes empty form to avoid errors before ngOnInit
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [false],
    });
  }

  ngOnInit(): void {
    // 1. Checks if there is a saved email in LocalStorage
    const savedEmail = localStorage.getItem('remember_email');

    if (savedEmail) {
      this.form.patchValue({
        email: savedEmail,
        rememberMe: true
      });
    }
  }

  protected sendLogin(): void {
    if (this.form.invalid) return;
    
    this.loading = true;
    const { email, password, rememberMe } = this.form.value;

    // 2. "Keep Connected" Logic
    if (rememberMe) {
      localStorage.setItem('remember_email', email);
    } else {
      localStorage.removeItem('remember_email');
    }

    // Calls service
    this.authService.login({ email, password }).add(() => {
        this.loading = false;
    });
  }

  /** Forgot Password Logic */
  showForgotPassword() {
    this.forgotPasswordVisible = true;
    // Pulls the email typed in login to facilitate
    this.recoveryEmail = this.form.get('email')?.value || '';
  }

  sendRecoveryLink() {
    if (!this.recoveryEmail) return;

    this.loadingRecovery = true;
    this.authService.forgotPassword(this.recoveryEmail).subscribe({
      next: () => {
        
        this.forgotPasswordVisible = false;
      },
      error: (err) => {
        
      }
    }).add(() => this.loadingRecovery = false);
  }
}
